<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<!-- 업체코드 -->
			<el-row :gutter="20">
				<el-col :span="6">
					<sf-input-group
						:label="getMessage_('QWCC000950')"
						:inputValue="searchParams.cpnyCd"
						:onChange="value => onChangeSearchParam({ key: 'cpnyCd', value })"
					/>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/PqyCpnyPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	async created() {
		await this.searchList();
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async searchList() {
			this.$sf_toggleLoading(true);
			await this.getPopupPqyCpnys_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		onUserPopupParams(param) {
			this.searchParams.userName = param.userName;
		},
		reset() {
			this.searchParams.userName = '';
		},
		onChangeSearchParam({ key, value }) {
			this.searchParams[key] = value;
		}
	}
};
</script>

<style></style>
